import React, { useMemo, useState } from "react";
import "./TimeIntervalPicker.css";

const timeToMinutes = (time) => {
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

const minutesToTime12h = (totalMinutes) => {
  let hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours === 0 ? 12 : hours;

  return `${hours}:${String(minutes).padStart(2, "0")} ${ampm}`;
};

const minutesToTimeJS = (totalMinutes) => {
  let hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours}:${String(minutes).padStart(2, "0")}`;
};

const TimeIntervalPicker = ({
  startTime = "09:00",
  endTime = "14:00",
  interval = 30,
  capacity = 5,
  estimado = 0,
  onSelect,
  actual = true,
  disponibilidad,
  reservados,
  seleccionados,
}) => {
  const [selected, setSelected] = useState(null);

  const slots = useMemo(() => {
    const start = timeToMinutes(startTime);
    const end = timeToMinutes(endTime);
    const list = [];

    for (let current = start; current <= end; current += interval) {
      list.push({
        minutes: current,
        time: minutesToTime12h(current),
        timeJS: minutesToTimeJS(current + estimado),
      });
    }

    return list;
  }, [startTime, endTime, interval, estimado]);

  const handleSelect = (item) => {
    setSelected(item.time);
    onSelect && onSelect(item);
  };

  const now = new Date();
  const minutactual = now.getHours() * 60 + now.getMinutes() + interval;

  return (
    <div className="time-container">
      {slots.map((item) => {
        const isSelected = selected === item.time;

        let disp = capacity;

        if (disponibilidad && disponibilidad[item.timeJS] != null) {
          disp -= disponibilidad[item.timeJS];
        }

        if (reservados && reservados[item.timeJS] != null) {
          disp -= reservados[item.timeJS];
        }
        if (seleccionados) {
          const itemtime = seleccionados.filter((ite) => {
            return ite.selectedTime === item.timeJS;
          });
          const cant = itemtime.reduce((acom, ita) => acom + ita.cantidad, 0);
          disp -= cant;
        }

        disp = Math.max(disp, 0);

        const late = actual && item.minutes < minutactual;

        return (
          <button
            key={item.time}
            className={`time-card
                            ${isSelected ? "selected" : ""}
                            ${late || disp <= 0 ? "disabled" : ""}
                        `}
            disabled={disp <= 0 || late}
            onClick={(e) => {
              e.preventDefault();
              handleSelect(item);
            }}
          >
            <div className="time-text">{item.time}</div>

            <div className="capacity-text">
              {disp <= 0 ? "Agotado" : `Cupo restante: ${disp}`}
            </div>

            {reservados && reservados[item.timeJS] && (
              <div className="capacity-text">
                Reservados: {reservados[item.timeJS]}
              </div>
            )}

            {late && <div className="capacity-text">Cerrado</div>}
          </button>
        );
      })}
    </div>
  );
};

export default TimeIntervalPicker;
